import { render, staticRenderFns } from "./EventTabDocuments.vue?vue&type=template&id=0b4d2066&scoped=true&"
import script from "./EventTabDocuments.vue?vue&type=script&lang=js&"
export * from "./EventTabDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d2066",
  null
  
)

export default component.exports